import { ICoordinates } from '../address.interfaces';

export class CoordinatesModel implements ICoordinates {
  constructor(public readonly lat: number | null, public readonly lng: number | null) {}
}
